import { registerQuery } from 'data-fetching-client';
import HttpClient from 'flow-doctor-lib/constants/HttpClient';

// There are other fields here and on the Page object but we don't need them

export const GET_PAGES_BY_ID = registerQuery({
  fieldName: 'pagesById',
  args: ['portalId', 'ids'],
  fetcher({
    portalId,
    ids
  }) {
    return HttpClient.get('content/api/v4/contents', {
      query: {
        portalId,
        limit: ids.length,
        includeDeleted: true,
        analyticsPageId__in: ids.toString()
      }
    });
  }
});

// There are other fields here but we don't need them

export const GET_CTA_BY_PLACEMENT_GUID = registerQuery({
  fieldName: 'ctaByPlacementGuid',
  args: ['portalId', 'placementGuid'],
  fetcher({
    portalId,
    placementGuid
  }) {
    return HttpClient.get('ctas/v3/placements/batch', {
      query: {
        portalId,
        includeCtaInfo: true,
        guid: [placementGuid]
      }
    });
  }
});
export const GET_PLACEMENT_BY_CTA_GUID = registerQuery({
  fieldName: 'placementByGuid',
  args: ['portalId', 'ctaGuid'],
  fetcher({
    portalId,
    ctaGuid
  }) {
    return HttpClient.get('ctas/v2/cta-to-placements', {
      query: {
        portalId,
        ctaGuid: [ctaGuid]
      }
    });
  }
});